import React from 'react'
import { Modal } from '../../../components/Modal/Modal'

export interface CrossClientStopModalProps {
  show: boolean
  loading: boolean
  onStop: () => void | Promise<void>
  onContinue: () => void | Promise<void>
}

export const CrossClientStopModal: React.FC<CrossClientStopModalProps> = ({ show, loading, onStop, onContinue }) => {
  return (
    <Modal
      show={show}
      onHide={onContinue}
      header={<h4>Stop this query?</h4>}
      body={<div>Your progress will be saved and you can view the partial results. To check all clients, you'll need to rerun the query.</div>}
      centered
      showFooterActions
      bodyClassName='px-4'
      footerPrimaryActionButtonVariant='danger'
      footerPrimaryActionTitle='Stop query'
      footerSecondaryActionTitle='Keep running'
      footerPrimaryActionLoading={loading}
      footerSecondaryActionDisabled={loading}
      onFooterPrimaryAction={onStop}
      onFooterSecondaryAction={onContinue}
    />
  )
}
